export default __webpack_public_path__ + "static/meshery-logo-light-text-2e70742e9703c033a14e7b747ec154f0.webp";